import { createReducer, on } from '@ngrx/store';
import { Page } from '@models/page.model';
import {
  cannotCreatePage,
  cannotDeletePage,
  cannotFetchPages,
  cannotUpdatePage,
  createPage,
  deletePage,
  fetchPages,
  pageCreated,
  pageDeleted,
  pagesFetched,
  pageUpdated,
  updatePage,
} from '../actions/page.actions';
import { SharedState } from './index';

export interface PageState extends SharedState {
  pages: Page[];
}

export const initialPageState: PageState = {
  loaded: false,
  isLoading: false,
  error: '',
  pages: [],
}

export const pageReducer = createReducer(
  initialPageState,
  on(fetchPages, (state) => ({...state, isLoading: true, error: '', loaded: false})),
  on(pagesFetched, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    pages: payload
  })),
  on(cannotFetchPages, (state, {error}) => ({...state, isLoading: false, loaded: false, error, pages: []})),
  on(updatePage, createPage, deletePage, (state) => ({
    ...state,
    isLoading: true,
    error: '',
    loaded: false
  })),
  on(pageUpdated, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    pages: state.pages.map(p => p.id === payload.id ? payload : p)
  })),
  on(pageCreated, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    pages: [...state.pages, payload]
  })),
  on(pageDeleted, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    pages: state.pages.filter(p => p.id !== payload)
  })),
  on(cannotUpdatePage, cannotCreatePage, cannotDeletePage, (state, {error}) => ({
    ...state,
    isLoading: false,
    loaded: false,
    error
  })),
);
